export default {
  errorsRootKey: 'targetNumbers',
  resource: 'calltrackings/target-numbers',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
